import React, { useState } from "react";
import { Select, TextInput, Button, Tabs } from "@mantine/core";
import Header from "../components/Header";
import Footer from "../components/Footer";

const RefundFundsP2p = () => {
  const [coin, setCoin] = useState("");
  const [address, setAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [activeTab, setActiveTab] = useState("address");

  const step1Done = coin !== "";
  const step2Done = address !== "";
  const step3Done = amount !== "";

  const progress = step3Done ? "100" : step2Done ? "66" : step1Done ? "33" : "0";

  return (
    <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
      <Header />

      {/* Stepper + Form */}
      <div className="flex max-w-[700px] mx-auto my-10">
        {/* Left Stepper */}
        <div className="relative mr-10">
          {/* Base line */}
          <div className="absolute left-1/2 top-4 -translate-x-1/2 w-1 h-[90%] bg-gray-400 rounded" />
          {/* Progress line */}
          <div
            className="absolute left-1/2 top-4 -translate-x-1/2 w-1 bg-yellow-400 rounded transition-all duration-500 ease-in-out"
            style={{ height: `${progress}%` }}
          />
          {/* Step circles */}
          <div
            className={`absolute left-1/2 -translate-x-1/2 w-8 h-8 rounded-full border-2 border-gray-400 flex items-center justify-center font-bold z-10 ${
              step1Done ? "bg-yellow-300" : "bg-white"
            }`}
            style={{ top: "5px" }}
          >
            1
          </div>
          <div
            className={`absolute left-1/2 -translate-x-1/2 w-8 h-8 rounded-full border-2 border-gray-400 flex items-center justify-center font-bold z-10 ${
              step2Done ? "bg-yellow-300" : "bg-white"
            }`}
            style={{ top: "30%" }}
          >
            2
          </div>
          <div
            className={`absolute left-1/2 -translate-x-1/2 w-8 h-8 rounded-full border-2 border-gray-400 flex items-center justify-center font-bold z-10 ${
              step3Done ? "bg-yellow-300" : "bg-white"
            }`}
            style={{ top: "70%" }}
          >
            3
          </div>
        </div>

        {/* Right Content */}
        <div className="flex-1">
          {/* Step 1 */}
          <div className="mb-12">
            <h3 className="mb-2 font-bold text-[21px]">Select coin</h3>
            <Select
              placeholder="Select coin"
              value={coin}
              onChange={setCoin}
              className="bg-transparent"
              data={[
                { value: "BTC", label: "BTC Bitcoin" },
                { value: "ETH", label: "ETH Ethereum" },
                { value: "WBTC", label: "WBTC Wrapped Bitcoin" },
              ]}
            />
          </div>

          {/* Step 2 */}
          <div className="mb-12">
            <h3 className="mb-2 font-bold text-[21px]">Withdraw to</h3>
            <Tabs defaultValue="address">
              <Tabs.List>
                <Tabs.Tab value="address">Address</Tabs.Tab>
                <Tabs.Tab value="user">Tillionx user</Tabs.Tab>
              </Tabs.List>

              <Tabs.Panel value="address" pt="sm">
                <TextInput
                  placeholder="Enter Address"
                  className="bg-transparent"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                <Select
                  placeholder="Select network"
                  className="bg-transparent mt-4"
                  data={["ERC20", "BEP20", "TRC20"]}
                />
              </Tabs.Panel>

              <Tabs.Panel value="user" pt="sm">
                <TextInput
                  placeholder="Enter Tillionx User ID"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Tabs.Panel>
            </Tabs>
          </div>

          {/* Step 3 */}
          <div>
            <h3 className="mb-2 font-bold text-[21px]">Withdraw amount</h3>
            <TextInput
              placeholder="Enter amount"
              className="bg-transparent"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
            <Button
              color="yellow"
              fullWidth
              className="mt-5"
              disabled={!step1Done || !step2Done || !step3Done}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>

      {/* Recent Withdrawals Section */}
      <div className="w-full max-w-7xl mx-auto mt-16">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold">Recent Withdrawals</h2>
          <div className="flex items-center space-x-4 text-sm">
            <label className="flex items-center space-x-1 cursor-pointer">
              <input
                type="checkbox"
                defaultChecked
                className="accent-yellow-500"
              />
              <span>Hide error notices</span>
            </label>
            <button className="text-gray-500 hover:text-black flex items-center">
              More <span className="ml-1">›</span>
            </button>
          </div>
        </div>

        {/* Tabs for history */}
        <div className="flex space-x-6 border-b mb-8">
          <button
            onClick={() => setActiveTab("address")}
            className={`pb-2 text-sm font-medium ${
              activeTab === "address"
                ? "border-b-2 border-black text-black"
                : "text-gray-500"
            }`}
          >
            Address
          </button>
          <button
            onClick={() => setActiveTab("user")}
            className={`pb-2 text-sm font-medium ${
              activeTab === "user"
                ? "border-b-2 border-black text-black"
                : "text-gray-500"
            }`}
          >
            Tillionx user
          </button>
        </div>

        {/* Empty states */}
        {activeTab === "address" && (
          <div className="flex flex-col items-center justify-center py-16 text-center text-gray-500">
            <div className="w-16 h-16 flex items-center justify-center mb-4">
              <img
                src="https://www.svgrepo.com/show/499831/file-search.svg"
                alt="No record"
                className="w-12 h-12 opacity-50"
              />
            </div>
            <p>No recent withdraw record.</p>
          </div>
        )}

        {activeTab === "user" && (
          <div className="flex flex-col items-center justify-center py-16 text-center text-gray-500">
            <div className="w-16 h-16 flex items-center justify-center mb-4">
              <img
                src="https://www.svgrepo.com/show/499831/file-search.svg"
                alt="No record"
                className="w-12 h-12 opacity-50"
              />
            </div>
            <p>No recent withdraw record for Tillionx user.</p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default RefundFundsP2p;
